import { apiUtils } from '../utils/apiUtils'

const jsonHeaders = { 'Content-Type': 'application/json' }

export default {
  get: function (code) {
    return fetch(apiUtils.client + '/' + code, {
      method: 'GET'
    }).then((res) => {
      console.log('res.status',res.status)
      if (res.status === 200) {
        return res.json()
      } else if (res.status === 404) {
        return { error: 'Code introuvable' }
      }
      if (res.status === 500) {
        return ({error: res.statusText})
      }
      return Promise.resolve({})
    })
  },
  setStep: function (code, step) {
    return fetch(apiUtils.client + '/step', {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ code: code, step: step })
    })
  },
  getEnrollment: function (code) {
    return fetch(apiUtils.integrationEnroll + '/' + code, {
      method: 'GET'
    }).then((res) => {
      if (res.status === 200) {
        return res.json()
      } else if (res.status === 404) {
        return { error: 'Aucun magasin trouvé' }
      } else if (res.status === 400) {
        return { error: 'Code d\'enrollment manquant' }
      } else if (res.status === 500) {
        return { error: 'Erreur serveur' }
      }
      return Promise.resolve({})
    }).catch(err => new Error('ERR_Erreur pendant l\'envoi du fichier', err))
  },
  complete: function (code) {
    return fetch(apiUtils.client + '/complete', {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ code: code })
    })
  },
  register: function (code, clientid) {
    return fetch(apiUtils.integrationEnroll + '/register/' + code, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ clientid: clientid })
    })
  },
  process: function (code) {
    return fetch(apiUtils.integrationEnroll + '/process/' + code, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({})
    })
  }
}
